import { Component, OnInit } from '@angular/core';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { Router } from '@angular/router';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-unauthorised',
  templateUrl: './unauthorised.component.html'
})
export class UnauthorisedComponent implements OnInit {

  constructor(public azureAuthService: AzureAuthService, private router: Router) { }

  ngOnInit(): void {
    if (this.azureAuthService.isAuthenticated()){
      this.router.navigate(['/home']);
    }
  }

  loginAzure() {
    this.azureAuthService.login().subscribe({
      next: (result: AuthenticationResult) => {
        // Authentication successful
        console.log('Login successful:', result);
        // Navigate to /home
        this.router.navigate(['/home']);
      },
      error: (error) => {
        // Handle authentication errors
        console.error('Login failed:', error);
        // Optional: Display an error message to the user
      }
    });
  }


  logout(){
    this.azureAuthService.logout();
  }
}
